export default __webpack_public_path__ + "static/media/matic-logo.6e808c42.png";